import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendar1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendar1"><Path d="M8.5 2V4H15.5V2H17V4H21V9H3V4H7V2H8.5Z" fill="currentColor"/><Path d="M3 10.5V21H21V10.5H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendar1;
